module.exports = __webpack_public_path__ + "assets/15c81d2864cedf3f1410daaaae07c305.mp3";